import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignatureRequestDocumentViewModel } from '../../models/signature-request.viewmodel';
import { SignatureRequestDocumentStatusBadgeComponent } from '../signature-request-document-status-badge/signature-request-document-status-badge.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RutPipe } from 'src/app/common/rut.pipe';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { SignatureSignatoryStatusBadgeComponent } from '../signature-signatory-status-badge/signature-signatory-status-badge.component';

/**
 * Component to display a list of signature request documents as cards.
 * This component is used to visually represent each document in a card layout for smaller screen devices.
 */
@Component({
  selector: 'signature-request-document-list-cards',
  standalone: true,
  imports: [CommonModule,
    SignatureRequestDocumentStatusBadgeComponent,
    SignatureSignatoryStatusBadgeComponent,
    MatExpansionModule,
    MatTooltipModule, 
    RutPipe],
  templateUrl: './signature-request-document-list-cards.component.html',
  styleUrls: ['./signature-request-document-list-cards.component.scss'],
  viewProviders: [MatExpansionPanel]
})
export class SignatureRequestDocumentListCardsComponent {
  @Input() documents: SignatureRequestDocumentViewModel[] = [];
}
